import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { db } from '../firebase';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';

const C = { gold: '#F0B429', bg: '#080810', card: '#14141f' };

export default function FixturePage() {
  const { t } = useTranslation();
  const [fixtures, setFixtures] = useState([]);
  const [loading, setLoading] = useState(true);
  const [groupFilter, setGroupFilter] = useState('todos');

  useEffect(() => {
    const fetchFixtures = async () => {
      try {
        const q = query(collection(db, 'fixtures'), orderBy('date', 'asc'));
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setFixtures(data);
      } catch (error) {
        console.error('Error cargando fixtures:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchFixtures();
  }, []);

  const groups = ['todos', ...new Set(fixtures.map(f => f.group).filter(Boolean))];
  const filteredFixtures = groupFilter === 'todos' 
    ? fixtures 
    : fixtures.filter(f => f.group === groupFilter);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
  };

  const renderFlag = (flag, teamCode) => {
    if (flag && typeof flag === 'string' && flag.trim() !== '') {
      return <span style={{ fontSize: '24px', lineHeight: 1 }}>{flag}</span>;
    }
    return <span style={{ fontSize: '14px', fontWeight: 'bold', color: C.gold }}>{teamCode}</span>;
  };

  if (loading) {
    return (
      <div style={{ background: C.bg, minHeight: '100vh', paddingTop: '80px', textAlign: 'center' }}>
        <p style={{ color: C.gold }}>{t('loading_fixture')}</p>
      </div>
    );
  }

  return (
    <div style={{ background: C.bg, color: '#F5F5F0', minHeight: '100vh', paddingTop: '80px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
        <Link to="/" style={{ color: C.gold, textDecoration: 'none', display: 'inline-block', marginBottom: '20px' }}>← {t('back_to_home')}</Link>
        
        <h1 style={{ fontFamily: "'Oswald', sans-serif", fontSize: '32px', marginBottom: '10px' }}>
          {t('fixture_title')} <span style={{ color: C.gold }}>{t('fixture_subtitle')}</span>
        </h1>
        <p style={{ color: '#888', marginBottom: '20px' }}>{t('fixture_description')}</p>

        <div style={{ marginBottom: '30px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {groups.map(g => (
            <button
              key={g}
              onClick={() => setGroupFilter(g)}
              style={{
                background: groupFilter === g ? C.gold : 'transparent',
                border: `1px solid ${groupFilter === g ? C.gold : 'rgba(255,255,255,0.2)'}`,
                borderRadius: '30px',
                padding: '6px 16px',
                color: groupFilter === g ? '#080810' : '#ccc',
                cursor: 'pointer',
                fontFamily: "'Oswald', sans-serif",
                fontSize: '13px',
                transition: 'all 0.2s',
              }}
            >
              {g === 'todos' ? t('all_groups') : `${t('group')} ${g.toUpperCase()}`}
            </button>
          ))}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {filteredFixtures.length === 0 && (
            <p style={{ textAlign: 'center', color: '#888' }}>{t('no_matches')}</p>
          )}
          {filteredFixtures.map((match) => (
            <div key={match.id} style={{ background: C.card, borderRadius: '14px', padding: '14px 20px', border: '1px solid rgba(255,255,255,0.08)', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
              <div style={{ minWidth: '100px' }}>
                <div style={{ fontSize: '14px', color: C.gold, fontWeight: 'bold' }}>{formatDate(match.date)}</div>
                <div style={{ fontSize: '11px', color: '#888' }}>{match.city || t('venue_tbd')}</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                {renderFlag(match.homeFlag, match.home)}
                <span style={{ fontWeight: 'bold', minWidth: '100px', textAlign: 'right' }}>{match.homeName || match.home}</span>
                <span style={{ color: C.gold, fontWeight: 'bold' }}>vs</span>
                <span style={{ fontWeight: 'bold', minWidth: '100px' }}>{match.awayName || match.away}</span>
                {renderFlag(match.awayFlag, match.away)}
              </div>
              <div style={{ fontSize: '12px', color: '#aaa', minWidth: '120px', textAlign: 'right' }}>
                {t('group')} {match.group?.toUpperCase()}
              </div>
            </div>
          ))}
        </div>
        <p style={{ textAlign: 'center', marginTop: '40px', color: '#555', fontSize: '12px' }}>
          {t('fixture_footer')}
        </p>
      </div>
    </div>
  );
}